<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Pending Settlement</span>

  <div class="flex flex-wrap items-center mt-6 gap-3">
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-black border border-black flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-black text-white">
        {{ counter.allCount }}
      </div>
      <span>All</span>
    </div>
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#FDCBAA] flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-[#F68E17]">
        {{ counter.receivedCount }}
      </div>
      <span>Received</span>
    </div>
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#85E2B1] flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-[#3DB474]">
        {{ counter.approvedCount }}
      </div>
      <span>Approved</span>
    </div>
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#FFE1E0] flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-[#FF6A65]">
        {{ counter.rejectedCount }}
      </div>
      <span>Rejected</span>
    </div>
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#FDE68A] flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-[#F59E0B]">
        {{ counter.unclosedCount }}
      </div>
      <span>Pending Settlement</span>
    </div>
    <div class="px-4 sm:px-6 py-3 rounded-xl font-medium text-black bg-gray-200 flex items-center space-x-3 justify-center">
      <div class="rounded-full h-8 w-8 flex items-center justify-center bg-gray-500 text-white">
        {{ counter.closedCount }}
      </div>
      <span>Closed</span>
    </div>
  </div>

  <div class="mt-6">
    <mat-divider class="!border-gray-300"></mat-divider>
  </div>

  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mt-6">
    <div class="relative w-full sm:w-1/2 lg:w-1/3">
      <input
        type="text"
        [formControl]="searchControl"
        class="w-full h-12 border border-gray-200 rounded-lg p-4 pl-11 text-[#5C5C5C] text-sm focus:outline-none"
        placeholder="Cari..."
      />
      <i class="fa-solid fa-magnifying-glass absolute left-4 top-4"></i>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0 mt-6 font-display min-w-max w-full"
    >

      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">No.</th>
        <td mat-cell *matCellDef="let element; let i = index">{{ parseNo(i) }}</td>
      </ng-container>

      <ng-container matColumnDef="staff">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Employee</th>
        <td mat-cell *matCellDef="let element">{{ getStaffName(element) }}</td>
      </ng-container>

      <ng-container matColumnDef="team">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Team</th>
        <td mat-cell *matCellDef="let element">{{ element.creator?.team?.name || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="refId">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Ref ID</th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.refId; else emptyRef"
            class="inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900"
          >#{{ element.refId }}</span>
          <ng-template #emptyRef>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Title</th>
        <td mat-cell *matCellDef="let element">{{ element.title || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Amount</th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          {{ element.amount != null ? (element.currency || '') + ' ' + (element.amount | number) : '-' }}
        </td>
      </ng-container>

      <ng-container stickyEnd matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Action</th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            [matMenuTriggerFor]="menu"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:border-slate-300 hover:text-slate-900"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="detail(element.id)">
              <span class="font-display text-sm">
                <i class="fa-solid fa-eye mr-3"></i>Detail
              </span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display">
            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400">
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700">No data available</span>
            <span class="text-xs text-slate-500">Try adjusting filters or search.</span>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [length]="dataTotal"
    [pageSize]="limit"
    [pageSizeOptions]="pageSizeOption"
    (page)="onPageChange($event)"
    aria-label="Select page"
  ></mat-paginator>
</section>
